"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var NavigationMenuPrimitive = _interopRequireWildcard(require("@radix-ui/react-navigation-menu"));
var _Shared = require("./Shared.styled");
var _jsxRuntime = require("react/jsx-runtime");
// Content item with styles

var StyledLink = (0, _styledComponents.default)(NavigationMenuPrimitive.Link).withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-o75js4-0"
})(["text-decoration:none;position:relative;display:flex;align-items:center;padding:", " ", " ", " ", ";color:", ";border-radius:0 ", " ", " 0;border-left:", " solid transparent;&:hover{background:", ";color:", ";}&:focus-visible{outline:none;}&[data-active]{border-color:", ";}:not(&[data-active]){", "}"], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['800'], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['400'], function (props) {
  return props.theme.sys.color.text.content.main;
}, _globalTokens.globalBorder.radius['2'], _globalTokens.globalBorder.radius['2'], _globalTokens.globalSizing['100'], function (props) {
  return props.theme.sys.color.background.primary['1'];
}, function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.theme.sys.color.border.active;
}, function (props) {
  return props.level > 0 ? "border-color: ".concat(props.theme.sys.color.background.disabled['1'], ";") : '';
});
var Link = function Link(_ref) {
  var children = _ref.children,
    href = _ref.href,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    theme = _ref.theme,
    props = _objectWithoutProperties(_ref, ["children", "href", "level", "isActive", "theme"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Shared.LevelContainer, {
    level: level,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, _objectSpread({
      href: href,
      level: level,
      active: isActive,
      onSelect: function onSelect(event) {
        return event.preventDefault();
      }
    }, props, {
      children: children
    }))
  });
};
var _default = exports.default = Link;